import { Items as VehicleInformation } from "../vehicle-search-details/vehicleSearch.type";
import getBatteryGradeLetter from "./getBatteryGradeLetter";

const getVehicleDataPush = (
  vehicleInfo: VehicleInformation,
  catalogueRef: string | string[],
  isTracked: boolean,
  note: string,
  mechReportCombo: string
) => ({
  vehicle: {
    batteryGrade: vehicleInfo.additionalInformation?.evBattery?.isApplicable
      ? `grade-${getBatteryGradeLetter(
          vehicleInfo.additionalInformation.evBattery.batteryCondition
        )}`
      : "",
    vrm: vehicleInfo.vrm,
    make: vehicleInfo.make,
    model: vehicleInfo.model,
    vehicleType: vehicleInfo.vehicleType,
    mechReportCombo,
    publishedSaleCode: catalogueRef,
    lotCode: vehicleInfo.lotNumber,
    saleType: vehicleInfo.saleType,
    saleCode: vehicleInfo.saleCode,
    saleBranch: vehicleInfo.localSaleLocation,
    trackStatus: isTracked ? "tracked" : "untracked",
    noteFlag: Boolean(note) ? "note_present" : "no_note",
  },
});

export default getVehicleDataPush;
